import { render, staticRenderFns } from "./CartBanners.vue?vue&type=template&id=350463f8&scoped=true"
import script from "./CartBanners.vue?vue&type=script&lang=ts"
export * from "./CartBanners.vue?vue&type=script&lang=ts"
import style0 from "./CartBanners.vue?vue&type=style&index=0&id=350463f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350463f8",
  null
  
)

export default component.exports